import React, { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import SpotlightHeader from '../../Common/Header';
import BottomBar from '../../../components/BottomBar';
import './Celebration.scss';
import { getOrdinalSuffixedNumber } from '../../helpers/boh_spotlights';
const STORAGE_KEYS = {
  boh_type_birthday: 'birthday-employee-index',
  boh_type_anniversary: 'anniversary-employee-index'
};
const getEmployee = (employees, storage_key) => {
  const nextIndex = (+localStorage.getItem(storage_key) + 1) % employees.length;
  localStorage.setItem(storage_key, nextIndex);
  return employees[nextIndex];
};
const formatBirthday = birthday => {
  if (!birthday) return '';

  // 2000 was a leap year
  const date = DateTime.fromFormat(`2000-${birthday}`, 'yyyy-MM-dd');
  const ordinal_suffixed_number = getOrdinalSuffixedNumber(date.day);
  return `${date.toFormat('MMMM')} ${ordinal_suffixed_number}`;
};
const formatAnniversary = anniversary => {
  if (!anniversary) return 'Happy Anniversary!';
  const anniversaryDate = DateTime.fromFormat(anniversary, 'yyyy-MM-dd');
  const difference = Math.abs(anniversaryDate.diffNow('years').years);
  const ordinal_suffixed_number = getOrdinalSuffixedNumber(Math.round(difference));
  return `Happy ${ordinal_suffixed_number} Anniversary!`;
};
const formatAnniversaryDate = anniversaryDate => {
  if (!anniversaryDate) return;
  const date = DateTime.fromFormat(anniversaryDate, 'yyyy-MM-dd');
  const ordinal_suffixed_number = getOrdinalSuffixedNumber(date.day);
  return `${date.toFormat('MMMM')} ${ordinal_suffixed_number}`;
};
function useEmployee(storage_key, data, metadata, type) {
  const [currentEmployee, setCurrentEmployee] = useState(null);
  useEffect(() => {
    if (!!(data !== null && data !== void 0 && data.employees) && (!currentEmployee || currentEmployee.name === 'N/A' || !data.employees.some(emp => emp.name === currentEmployee.name))) {
      setCurrentEmployee(getEmployee(data.employees, storage_key));
    }
  }, [data, currentEmployee, storage_key, metadata.boh_employee, type]);
  return type.includes('single_employee') ? metadata.boh_employee : currentEmployee;
}
const Celebration = props => {
  const {
    metadata,
    bohStyle,
    text,
    data,
    type
  } = props;
  const storage_key = STORAGE_KEYS[type];
  const hide_poweredbyshift = metadata.hide_poweredbyshift;
  const showBirthDate = (metadata === null || metadata === void 0 ? void 0 : metadata.boh_show_birth_date) && (type === 'boh_type_birthday' || type === 'boh_type_birthday_single_employee');
  const showAnniversary = (metadata === null || metadata === void 0 ? void 0 : metadata.boh_show_anniversary) && (type === 'boh_type_anniversary' || type === 'boh_type_anniversary_single_employee');
  const showAnniversaryDate = (metadata === null || metadata === void 0 ? void 0 : metadata.boh_show_anniversary_date) && (type === 'boh_type_anniversary' || type === 'boh_type_anniversary_single_employee');
  const showJobTitle = metadata === null || metadata === void 0 ? void 0 : metadata.boh_show_job_title;
  const hideTitle = metadata === null || metadata === void 0 ? void 0 : metadata.boh_hide_title;
  const currentEmployee = useEmployee(storage_key, data, metadata, type);
  const formattedTitle = showAnniversary && !!currentEmployee ? {
    ...text,
    title: formatAnniversary(currentEmployee.start_date)
  } : text;
  const {
    accent_color,
    text_accent_color,
    containerStyle
  } = bohStyle;
  return /*#__PURE__*/React.createElement("div", {
    className: "celebration-container",
    style: containerStyle
  }, /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: formattedTitle,
    metadata: metadata,
    hideTitle: hideTitle
  }), /*#__PURE__*/React.createElement("div", {
    className: "celebration-info-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "celebration-info"
  }, !!currentEmployee && /*#__PURE__*/React.createElement("div", {
    className: "celebration-info-title"
  }, /*#__PURE__*/React.createElement("div", null, currentEmployee.name), showJobTitle && currentEmployee.job_title && /*#__PURE__*/React.createElement("div", {
    className: "celebration-job-title"
  }, currentEmployee.job_title), /*#__PURE__*/React.createElement("div", {
    className: "celebration-date"
  }, showBirthDate && formatBirthday(currentEmployee.birthday)), /*#__PURE__*/React.createElement("div", {
    className: "celebration-date"
  }, showAnniversaryDate && formatAnniversaryDate(currentEmployee.start_date))))), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    hide_poweredbyshift: hide_poweredbyshift
  }));
};
export default Celebration;